import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const OAuth2RedirectHandler = () => {
  const navigate = useNavigate();

  useEffect(async () => {
    const setToken = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token"); // El backend debe enviar un token en el redirect
      const error = params.get("error");

      if (token) {
        sessionStorage.setItem("authToken", token); // Guarda el token

        const response1 = await api.get("/"); // Llama al backend para validar el token
        const userData1 = response1.data;
        if (userData1) {
          sessionStorage.setItem("user", JSON.stringify(userData1.user));
          
          document.location.href = "/main";
          return;
        }

        document.location.href = "/login";

        //navigate("/main");  // Redirige al área privada
      } else {
        console.error("Error de autenticación:", error);
        sessionStorage.removeItem("authToken");
        sessionStorage.removeItem("user");

        //document.location.href ='/login';
        //navigate("/login");  // Redirige al login en caso de fallo
        return;
      }
    };

    setToken();
  }, [navigate]);

  return <p>Procesando login...</p>;
};

export default OAuth2RedirectHandler;
